import React from 'react';
import './FooterDescribe.scss';

const FOOTER_DESCRIBE_MAP = {
    photo: (
        <>
            <p>Beaucoup de Voissanautes choisissent la photo pour s'exhiber : <strong>Photo sexe</strong> ou coquine, habillé ou nu... chacun peut s'épanouir à son rythme sur Voissa en fonction de ses envies.</p>
                <p>Revenez régulièrement car vous verrez que les mises à jour sont incessantes et que les <strong>contributions amateur</strong> sont faites pour vous plaire, donner envie de commenter et offrir un "j'aime".</p>

                <p><span>Des photos sexe ? Oui mais surtout de l'exhib amateur et des contributions réalisées avec passion !</span></p>

                <p>A l'aide des différents tags, retrouvez les albums de photos qui vont vous plaire :
                    Fétichisme, en couple, sodomie, dans la cuisine, amateur, en bikini, gros seins (et
                    petits seins bien sûr), sextoy, en trio (et parfois même plus), en uniforme, dans la
                    piscine, dans la nature, à la plage, certaines femmes sont même tatouées, sadomaso, en
                    lingerie et bien plus.</p>

                <p>Beaucoup de photos plairont aux amateurs de jolies femmes exhib, de jolis couples, mais
                    sur Voissa beaucoup d'hommes produisent également un contenu de grande qualité, en
                    valorisant des clichés de leur torse et de leurs fesses plutôt que de leur pénis en gros
                    plan.</p>

                <p>Vos photos et vos snaps ne peuvent plus rester bloqués sur votre téléphone portable (ou
                    votre ordinateur), écoutez vos désirs et partagez les avec notre communauté, nous vous
                    attendons parmi nous sur Voissa.</p>
        </>
    ),
    video : (
        <>
            <p>Si vous aimez les vidéos amateur et que vous aimez découvrir l'univers de ceux qui les publient, peut-être que vous ne quitterez plus jamais Voissa.</p>

            <p>Depuis 20 ans, les membres de notre communauté ont publié des dizaines de milliers de vidéos de leur intimité. En couple, en solo ou à plusieurs, dans leur maison ou chez les autres. Des vidéos sensuelles, des vidéos plus sexuelles voire parfois même des <strong>vidéos porno</strong> (non ce n'est pas un gros mot), chacun profite de Voissa au gré de ses envies et reste libre de se montrer comme il a envie d'être vu.</p>

            <p>Voissa est devenu la plus grande source de <strong>vidéos amateur</strong> car nos membres s'y sentent en sécurité, ils aiment l'esprit de respect et de partage qui y règne, ils apprécient de savoir que leur exhibition s'arrête aux portes de notre communauté, qu'ils ne pourront pas être vus par n'importe qui.</p>

            <p>A nous lire vous pensez peut-être que c'est payant, pourtant non, profiter des vidéos sur Voissa est 100% gratuit, sur ordinateur, mobile ou tablette, vous profitez du meilleur sans rien débourser.</p>

            <p><span>Vidéo porno ? Non sur Voissa nous valorisons le contenu amateur de qualité !</span>
            </p>

            <p>Nos membres se mettent en scène car ils aiment qu'on regarde leur intimité, ils font
                attention à produire du contenu de grande qualité (notamment les Voissa créateurs) et
                beaucoup d'entre eux adorent qu'on les commente donc si vous avez une minute il est
                primordial de leur dire à quel point vous aimez ce qu'ils publient (un commentaire, un
                like, c'est vous qui décidez).</p>

            <p>Nous avons conscience que tout le monde ne souhaite pas (en tout cas pas tout de suite)
                voir des <strong>vidéos de sexe</strong>. Nous avons donc mis en place un filtre pour
                privilégier le contenu de qualité (longue durée). Vous disposez aussi d'un menu pour
                vous aider à choisir entre différents thème. Les titres devraient vous guider, libre à
                vous de passer la porte pour voir une vidéo porno ou une vidéo plus soft :</p>

            <p>Tout en douceur, vidéos de sexe charnel (Bestial), les trios (plans à trois qui n'en a
                jamais rêvé), à plusieurs (plus de trois personnes), masqués pour les fétichistes, jeux
                sensuels pour les coquins, en plein air, en public, à la maison (amateur), entre elles
                pour ceux qui aiment le sexe lesbien, de elle à lui (souvent une fellation), de lui à
                elle (cunnilingus), les caresses féminines (madame se touche) et une dernière catégorie
                ou sont présentes uniquement les vidéos soft.</p>
        </>
    ),
    home : (
        <>
            <p>Voissa est né pour permettre à ses membres de trouver un lieu dans lequel ils pourraient
                discuter, partager et se dévoiler en toute liberté. En 1999 le web débute, peu de sites
                répondent à cette demande et pourtant Voissa est déjà là, ce petit jardin secret fréquenté
                par quelques centaines de personnes.</p>

            <p>Depuis lors Voissa a évolué et bien entendu grossi. Plus de 100 000 personnes viennent
                désormais quotidiennement profiter de notre communauté, pour se montrer ou simplement
                regarder, pour discuter, débattre, commenter ou simplement lire.</p>

            <p>Les années n'ont pas dévié Voissa de son objectif, restant fidèle à son ADN, continuant de
                faire de sa communauté un lieu ou règne le respect, la bonne humeur et l'envie commune de
                voir ses membres s'épanouir sexuellement.</p>

            <p>En vous baladant sur Voissa vous trouverez des photos et vidéos sexuelles. La liberté c'est
                aussi de permettre à chacun de s'exprimer, qu'il souhaite publier une vidéo <a
                    href="https://www.jacquieetmicheltv.net" target="_blank"
                    rel="noopener noreferrer">porno</a> ou plus sensuelle, chacun utilise son profil comme
                il l'entend.</p>
        </>
    )
}

const FooterDescribe = ({kind='photo'}) => {
    return (
        <div className="footer-describe">
            {FOOTER_DESCRIBE_MAP[kind] || null}
        </div>
    );
};

export default FooterDescribe;
